import { useEffect, useState } from "react";

export const useCarousel = (count, intervalMs = 7000) => {
    const [index, setIndex] = useState(0);
    const next = () => setIndex((i) => (i + 1) % count);
    const prev = () => setIndex((i) => (i - 1 + count) % count);

    useEffect(() => {
        const id = setInterval(() => setIndex((i) => (i + 1) % count), intervalMs);
        return () => clearInterval(id);
    }, [index, count, intervalMs]);

    return { index, next, prev, select: setIndex };
};
